import React from 'react';
import { useState } from 'react';

const GenericPolicyEn = () => {
   const [lastUpdated] = useState('April 12, 2025');

   // Simple inline styles for responsiveness
   const styles = {
      container: {
         maxWidth: '1200px',
         margin: '0 auto',
         padding: '20px',
         fontFamily: 'Arial, sans-serif',
      },
      header: {
         textAlign: 'center',
         marginBottom: '40px',
      },
      title: {
         fontSize: '32px',
         color: '#1976d2',
         marginBottom: '16px',
         fontWeight: 'bold',
      },
      date: {
         fontSize: '16px',
         color: '#666',
         marginBottom: '16px',
      },
      section: {
         marginBottom: '32px',
         backgroundColor: 'white',
         borderRadius: '8px',
         padding: '24px',
         boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
      },
      sectionTitle: {
         fontSize: '24px',
         color: '#1976d2',
         marginBottom: '16px',
         fontWeight: 'bold',
      },
      paragraph: {
         fontSize: '16px',
         lineHeight: 1.6,
         color: '#333',
         marginBottom: '16px',
      },
      list: {
         marginLeft: '24px',
         marginBottom: '16px',
      },
      listItem: {
         fontSize: '16px',
         lineHeight: 1.6,
         color: '#333',
         marginBottom: '8px',
      },
      footer: {
         textAlign: 'center',
         marginTop: '40px',
         paddingTop: '20px',
         borderTop: '1px solid #eee',
         color: '#666',
      },
   };

   // Adding some basic media query responsiveness
   if (window.innerWidth <= 768) {
      styles.container.padding = '16px';
      styles.header.marginBottom = '24px';
      styles.title.fontSize = '24px';
      styles.sectionTitle.fontSize = '20px';
      styles.paragraph.fontSize = '14px';
      styles.listItem.fontSize = '14px';
      styles.section.padding = '16px';
      styles.section.marginBottom = '24px';
   }

   return (
      <div style={styles.container}>
         <header style={styles.header}>
            <h1 style={styles.title}>Privacy Policy</h1>
            <p style={styles.date}>Last updated: {lastUpdated}</p>
         </header>

         <section style={styles.section}>
            <h2 style={styles.sectionTitle}>Introduction</h2>
            <p style={styles.paragraph}>
               Welcome to our Privacy Policy. This document explains how we collect, use, and protect your personal information when you use our services.
               We respect your privacy and are committed to protecting your personal data. Please read this Privacy Policy carefully to understand our practices regarding your personal data.
            </p>
         </section>

         <section style={styles.section}>
            <h2 style={styles.sectionTitle}>Information We Collect</h2>
            <p style={styles.paragraph}>We may collect the following types of information:</p>
            <ul style={styles.list}>
               <li style={styles.listItem}>Personal Information: name, email address, phone number, and other similar contact data.</li>
               <li style={styles.listItem}>Usage Data: information about how you use our services.</li>
               <li style={styles.listItem}>Device Information: information about the device you use to access our services.</li>
               <li style={styles.listItem}>Location Data: information about your location if you choose to share it.</li>
            </ul>
         </section>

         <section style={styles.section}>
            <h2 style={styles.sectionTitle}>How We Use Your Information</h2>
            <p style={styles.paragraph}>We use your information for various purposes, including:</p>
            <ul style={styles.list}>
               <li style={styles.listItem}>To provide and maintain our services.</li>
               <li style={styles.listItem}>To notify you about changes to our services.</li>
               <li style={styles.listItem}>To allow you to participate in interactive features of our services.</li>
               <li style={styles.listItem}>To provide customer support.</li>
               <li style={styles.listItem}>To gather analysis or valuable information to improve our services.</li>
               <li style={styles.listItem}>To monitor the usage of our services.</li>
               <li style={styles.listItem}>To detect, prevent, and address technical issues.</li>
            </ul>
         </section>

         <section style={styles.section}>
            <h2 style={styles.sectionTitle}>Data Security</h2>
            <p style={styles.paragraph}>
               We implement appropriate security measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction.
               However, no method of transmission over the Internet or method of electronic storage is 100% secure, and we cannot guarantee absolute security.
            </p>
         </section>

         <section style={styles.section}>
            <h2 style={styles.sectionTitle}>Third-Party Services</h2>
            <p style={styles.paragraph}>
               We may employ third-party companies and individuals to facilitate our services, provide services on our behalf, perform service-related services, or assist us in analyzing how our services are used.
               These third parties have access to your personal data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.
            </p>
         </section>

         <section style={styles.section}>
            <h2 style={styles.sectionTitle}>Your Rights</h2>
            <p style={styles.paragraph}>Depending on your location, you may have certain rights regarding your personal data, including:</p>
            <ul style={styles.list}>
               <li style={styles.listItem}>The right to access and obtain a copy of your personal data.</li>
               <li style={styles.listItem}>The right to rectify any inaccurate or incomplete personal data.</li>
               <li style={styles.listItem}>The right to erase your personal data.</li>
               <li style={styles.listItem}>The right to restrict the processing of your personal data.</li>
               <li style={styles.listItem}>The right to data portability.</li>
               <li style={styles.listItem}>The right to object to the processing of your personal data.</li>
            </ul>
         </section>

         <section style={styles.section}>
            <h2 style={styles.sectionTitle}>Changes to This Privacy Policy</h2>
            <p style={styles.paragraph}>
               We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date at the top of this Privacy Policy.
               You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.
            </p>
         </section>

         <section style={styles.section}>
            <h2 style={styles.sectionTitle}>Contact Us</h2>
            <p style={styles.paragraph}>
               If you have any questions about this Privacy Policy, please contact us:
            </p>
            <ul style={styles.list}>
               <li style={styles.listItem}>By email: haggaimagen87@gmail.com</li>
            </ul>
         </section>

         <footer style={styles.footer}>
            <p style={styles.paragraph}>© 2025 Hagidev Studios. All rights reserved.</p>
         </footer>
      </div>
   );
};

export default GenericPolicyEn;